module.exports = __webpack_public_path__ + "media/images/slider_img_02-ecb914098a4389a5be76494f07dd60ba.png";